"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const trace = false;
let all;
let all_index;
const fields = ['1-alpha2', '2-alpha3', '2T-alpha3', '2B-alpha3', '3-alpha3'];
function build() {
    if (all == null) {
        trace && console.time('ISO639 db');
        all_index = {};
        const dep = require('langs').all();
        all = dep.map((depData) => {
            const isoData = {
                name: depData.name,
                name_local: depData.local,
                '1-alpha2': depData['1'],
                '2-alpha3': depData['2'],
                '2T-alpha3': (depData['2T'] !== depData['2']) ? depData['2T'] : undefined,
                '2B-alpha3': (depData['2B'] !== depData['2']) ? depData['2B'] : undefined,
                '3-alpha3': depData['3']
            };
            for (let i = 0; i < fields.length; ++i) {
                const field = isoData[fields[i]];
                if (field) {
                    const value = field.toLowerCase();
                    if (value) {
                        if (trace) {
                            const previous_entry = all_index[value];
                            if (previous_entry && (isoData !== previous_entry)) {
                                trace && console.error(`ISO639 ${isoData} conflicts with ${previous_entry}`);
                            }
                        }
                        all_index[value] = isoData;
                    }
                }
            }
            return isoData;
        });
        trace && console.timeEnd('ISO639 db');
    }
}
function getList() {
    build();
    return all;
}
exports.getList = getList;
function find(data) {
    build();
    const dataLC = data.toLowerCase();
    const isoData = all_index[dataLC];
    return isoData;
}
exports.find = find;
//# sourceMappingURL=iso-639-impl.js.map